import {Pipe, PipeTransform} from "@angular/core";
import { formatNumber, parsePhoneNumberFromString  } from 'libphonenumber-js';

@Pipe({
    name: 'phone',
    standalone: false
})
export class PhonePipe implements PipeTransform {

  /*
  transform(value: string, args?: string) : string {
    if (!value.trim().length)
      return "";

    return formatNumber({ country: "US", phone: value}, 'International');
  }
  */

  // new process (it only takes a string now)
  transform(value: string, args?: string): string {
    if (!value || !value.trim().length) return "";

    const phoneNumber = parsePhoneNumberFromString(value, "US");
    return phoneNumber ? phoneNumber.formatInternational() : value;
  }
}